export default __webpack_public_path__ + "static/grand_hotel_2-20737171a578873f45d9d734323b3114.webp";